export default class LocalStorageService {
  static getValueFromLocalStorage = (key: string): string | null => {
    const value = LocalStorageService.get(key);
    if (value === undefined || value === "undefined") return null;

    if (value === null || value === "null") return null;

    return value;
  };

  static get(key: string): string | null | undefined {
    if (typeof window !== "undefined") {
      return localStorage.getItem(key);
    }
  }

  static set(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }

  static remove(key: string): void {
    window.localStorage.removeItem(key);
  }

  static clear(): void {
    window.localStorage.clear();
  }
}
